/**
 * FS-04 · FS-03 · FS-14 의존성 — 커널 호스트(C-05) · 코스 뷰(C-02) · 고스트 후보. 기본은 실제 구현을 늦게 불러오고,
 * 가짜 모드(VITE_FIELD_FAKE=1 · 개발 서버)는 가짜 호스트(친구 리플레이는 가짜 API), 시험은 set*ForTests 로 바꾼다.
 */
import { readConfig } from "../../../lib/config";
import { DRACO_PATH } from "../../../lib/preview";
import { combineSources, serverGhostSource } from "./ghosts";
import { outboxGhostSource } from "./replaySave";
import type { CourseDeps } from "../types";

const fakeMode = () => import.meta.env.DEV && readConfig().fake;

const defaults: CourseDeps = {
  fake: fakeMode(),
  async createHost() {
    if (import.meta.env.DEV && readConfig().fake) {
      const [{ createFakeHost }, fc] = await Promise.all([
        import("./fakeHost"),
        import("../../../dev/fake/fakeCourse"),
      ]);
      const { readFs03Scenario, readFs14Scenario } = await import("../../../dev/fake/fakeSocial");
      return createFakeHost({
        ...fc.fakeHostOptions(fc.readFs04Scenario(), { fe501: readFs14Scenario().has("fe501") }),
        gallerySlots: readFs03Scenario().has("slots"),
      });
    }
    const { createLocalHost } = await import("@picnic-field/local-host");
    return createLocalHost();
  },
  async createView(canvas, opts) {
    const { createCourseView } = await import("@picnic-field/renderer");
    return createCourseView(canvas, { ...opts, dracoPath: DRACO_PATH });
  },
  async createDecorPreview(canvas) {
    const { createDecorPreview } = await import("@picnic-field/renderer");
    return createDecorPreview(canvas, { dracoPath: DRACO_PATH });
  },
  async createGalleryView(canvas, opts) {
    const { createGalleryView } = await import("@picnic-field/renderer");
    return createGalleryView(canvas, { ...opts, dracoPath: DRACO_PATH });
  },
  async ghostSource(ctx) {
    return combineSources(serverGhostSource(ctx), outboxGhostSource(ctx.mineLabel));
  },
};

let current: CourseDeps = defaults;

export function courseDeps(): CourseDeps {
  return current;
}

/** 시험 전용 — 부분만 바꾸고, null 이면 기본값으로 */
export function setCourseDepsForTests(over: Partial<CourseDeps> | null) {
  current = over ? { ...defaults, ...over } : defaults;
}
